import { confirmAlert } from "react-confirm-alert";

/**
 * Currency text to currency format
 * @param {*} n 
 * @param {*} currency 
 * @returns 
 */
export const infoAlert = (title, body) => {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <div className='custom-ui'>
                    <h3><i className="fas fa-exclamation-circle"></i>&nbsp;{title}</h3>
                    <p>{body}</p>
                    <div className="text-center">
                        <button className="btn btn-secondary" onClick={onClose}><i className="fas fa-times"></i>&nbsp;Cerrar</button>
                    </div>
                </div>
            )
        }
    });
}

/**
 * Extracts the YouTube video ID from a given YouTube URL.
 * 
 * Supports multiple URL formats:
 *  - https://www.youtube.com/watch?v=VIDEO_ID
 *  - https://youtu.be/VIDEO_ID
 *  - https://www.youtube.com/embed/VIDEO_ID
 *  - https://www.youtube.com/v/VIDEO_ID
 * 
 * @param {string} url - The YouTube URL to extract the video ID from.
 * @returns {string|null} The YouTube video ID if found, otherwise null.
 */
export const getYouTubeId = (url) => {
    const regex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?.*v=|embed\/|v\/))([^?&\/#]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
}